module.exports = __webpack_public_path__ + "img/txt.fdf5c59a.png";